import { HhtmFromLabel } from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/activate_hhpro_button_click';

import { CurrencyType } from 'src/components/FormatMoney/CurrencyType';
import { SubscriptionAction } from 'src/hooks/hhPro/usePayment';
import useSubscribeAction from 'src/hooks/hhPro/useSubscribeAction';
import { FormState } from 'src/types/HhProFormState';
import { UserSubscription } from 'src/types/hhpro';

import CancelButton from 'src/pages/HhProPromo/components/SubscribeControl/CancelButton';
import PayButton from 'src/pages/HhProPromo/components/SubscribeControl/PayButton';
import RenewButton from 'src/pages/HhProPromo/components/SubscribeControl/RenewButton';

const ActionComponentMap = {
    [SubscriptionAction.Payment]: PayButton,
    [SubscriptionAction.Cancel]: CancelButton,
    [SubscriptionAction.Renew]: RenewButton,
};

const SubscribeControlButton: React.FC<{
    subscription?: UserSubscription;
    price: number;
    currency: CurrencyType;
    tariffId: string;
    stretched?: boolean;
    initPayment: () => void;
    initCancel: () => void;
    initRenew: () => void;
    formState: FormState;
    setFormState: (formState: FormState) => void;
    label: HhtmFromLabel;
}> = ({ subscription, ...params }) => {
    const action = useSubscribeAction(subscription);
    if (!action) {
        return null;
    }
    const Component = ActionComponentMap[action];
    return <Component {...params} />;
};

export default SubscribeControlButton;
